document.addEventListener("DOMContentLoaded", function() {
    var downloadButton = document.getElementById('downloadICS');

    if (downloadButton) {
        downloadButton.addEventListener("click", function(event) {
            event.preventDefault();
            var projectElements = document.querySelectorAll('.project');
            var icsContent = generateICSContent(projectElements);
            downloadICS(icsContent);
        });

        function generateICSContent(elements) {
            var icsContent = "BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//Waste//Calendar//EN\r\n";
            elements.forEach(function(element) {
                var icsEvent = [
                    "BEGIN:VEVENT",
                    "UID:" + element.querySelector(".icsId").textContent,
                    "DTSTAMP:" + element.querySelector(".dtsStamp").textContent,
                    "DTSTART:" + element.querySelector(".icsStart").textContent,
                    "DTEND:" + element.querySelector(".icsEnd").textContent,
                    "SUMMARY:" + element.querySelector(".icsTitle").textContent,
                    "DESCRIPTION:" + element.querySelector(".icsDescription").textContent,
                    "LOCATION:" + element.querySelector(".icsLocation").textContent,
                    "END:VEVENT"
                ].join("\r\n");
                icsContent += icsEvent + "\r\n";

            });
            icsContent += "END:VCALENDAR\r\n";
            return icsContent;

        }

        function downloadICS(content) {
            var hiddenElement = document.createElement("a");
            hiddenElement.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(content);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'waste_calendar.ics';
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
            document.body.removeChild(hiddenElement);
        }
    }
});
